<template>
  <CenterWrapper>
    <ContentFrame>
        <LessonCTA
          class="navButton"
          v-show="isLoggedIn()"
          @click="handleLogout()"
        >
          Log out
        </LessonCTA>
        <LessonCTA
          class="navButton"
          v-show="!isLoggedIn()"
          @click="handleLogin()"
        >
          Log In
        </LessonCTA>
      <PageTitle>
        Completed
      </PageTitle>
      <div v-if="$store.state.completions.length == 0">
        <LessonCard>
          <ChoiceBlurb>Your completed videos will show up here for reference</ChoiceBlurb>
        </LessonCard>
      </div>
      <div
      v-for="completion in $store.state.completions"
      >
      <LessonCard>
        <div
          class="videoThumbContainer"
          v-bind:style="{ backgroundImage: `url(${completion.step.thumbnail})` }"
          >
        </div>
        <div class="videoInfo">

          <div class="videoTitle">
            {{completion.step.name}}
          </div>

          <div class="description">
            {{completion.step.description}}
          </div>
          <div class="videoMeta">

          </div>

        </div>
        <div class="ctaStepContainer">
          <LessonCTA
            v-on:click="openVideo(completion.step)"
            >

            <div>Re-watch</div>
          </LessonCTA>
          <div class="videoStep">
          <!-- nothin here, used to be 1 of 7 -->
          </div>
        </div>
      </LessonCard>


    </div>
    </ContentFrame>
  </CenterWrapper>
</template>


<script>
import { isLoggedIn, login, logout } from '../utils/auth'
import VideoView from './VideoView.vue'

export default {
  name: 'app-nav',
  methods: {
    handleLogin() {
      login()
    },
    handleLogout() {
      logout()
    },
    isLoggedIn() {
      return isLoggedIn()
    },
    openVideo(step) {
      this.$store.commit('setCompletionStepForModal', step)
      this.$modal.show(
        "historyVideoModal", {
          adaptive: true
        }, {
          width: "80%",
          height: "80%"
        }
      )
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.navButton{
  margin-top:15px;
  margin-left: 10px;
}

/* START COPIED FROM HOME VIEW - CONSOLIDATE */

.description{
  color: #444444;
  font-size: 14px;
  line-height: 133.4%;
}
.videoThumbContainer{
  width: 227px;
  height: 141px;
  background-size: cover;
}
/* UGLY, needs an explicit style for mobile
three div row layout not great
*/
@media (max-width: 600px) {
  .videoThumbContainer{
    width: 141px;
    height: 141px;
    background-position: center;
    background-size: cover;
  }
}

.ctaStepContainer{
  height: 100px;
  margin-left: auto;
  padding-right: 21px;
  display: flex;
  /*
  justify-content: flex-end;
  */
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 600px) {
  .ctaStepContainer{
    height: 70px;
    margin-left: auto;
    padding-right: 10px;
  }
  .ctaDecisionContainer{

  }
}
.videoStep{
  font-size: 39px;
}
.videoInfo{
  font-family: 'Roboto', sans-serif;

  width: 313px;
  display: flex;
  flex-direction: column;
  height: 141px;
  justify-content: space-between;
  padding-left: 21px; /* same as left pad of LessonCard */
}

@media (max-width: 600px) {
  .videoInfo{
    width: 250px;
  }
}

.videoTitle{
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  /* identical to box height */
  color: #444444;
}

.videoMeta{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;

  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.115em;

  text-transform: uppercase;
  color: #444444;
}


</style>



// WEBPACK FOOTER //
// src/components/AppNav.vue